const colors = {
  background: '#F2F3FF',
  primary: '#F68647',
  primaryDark: '#D96B2B',
  accent: '#5666F5',
  text: '#1F1F1F',
  muted: '#6B6B6B',
  border: '#E5E5E5',
  email: '#5666F5',
  emailAlt: '#1F1F1F',
  time: '#F68647',
  success: '#10B981'
};

export default colors;
